// src/tabs/messages/preview-link-placeholders.js — micro-fix libellés preview.
//
// PREVIEW UNIQUEMENT (éditeur de messages Plateformes). Les 3 variables de
// LIENS ({livret_url}, {welcome_form_url}, {paiement_caution_url}) sont
// générées PAR JETON au moment de l'envoi réel : c'est lib/messages-engine.js
// (serveur) qui injecte ctx.livret_url / ctx.welcome_form_url /
// ctx.paiement_caution_url. En aperçu client ces clés ctx n'existent pas →
// resolveValue rend '' et la variable disparaissait SILENCIEUSEMENT de
// l'aperçu (perçu comme un bug alors que le lien est impossible à générer
// ici, zéro jeton JIT). On pose donc dans le ctx d'APERÇU un placeholder
// honnête, visible tel quel dans le rendu texte.
//
// ⚠️ ZÉRO impact envoi : ce module vit dans src/tabs/messages/ (UI client)
// et n'est importé par AUCUN chemin serveur — le moteur d'envoi
// (lib/messages-engine.js + twin CJS lib/template-variables.js) est intouché,
// tout comme le résolveur partagé src/lib/template-variables.js.

export const PREVIEW_LINK_PLACEHOLDER = "[lien généré à l'envoi]";

// Les 3 variables de liens générés à l'envoi (jeton par résa).
export const PREVIEW_LINK_KEYS = [
  "livret_url",
  "welcome_form_url",
  "paiement_caution_url",
];

// LOT 3 — valeurs NON-LIEN générées à l'envoi. {code_promo} est résolu JIT par
// lib/messages-engine.js (lib/promo-codes.js::getOrRefreshPromoCode, qui ÉCRIT
// en base) : impossible à produire en aperçu client (zéro mutation ici). Sans
// placeholder la variable disparaîtrait SILENCIEUSEMENT de l'aperçu — même
// piège que les liens (#1003). Libellé DISTINCT de celui des liens : ce n'est
// pas une URL, et l'admin doit lire ce qu'il verra.
export const PREVIEW_CODE_PLACEHOLDER = "[code généré à l'envoi]";
export const PREVIEW_CODE_KEYS = ["code_promo"];

// Décore un ctx d'aperçu : pose le placeholder sur les clés de liens (et les
// valeurs JIT non-lien) que le moteur serveur injecte à l'envoi. Ne touche à
// rien d'autre (spread pur).
export function withPreviewLinkPlaceholders(ctx) {
  const out = { ...ctx };
  for (const key of PREVIEW_LINK_KEYS) out[key] = PREVIEW_LINK_PLACEHOLDER;
  for (const key of PREVIEW_CODE_KEYS) out[key] = PREVIEW_CODE_PLACEHOLDER;
  return out;
}
